export default "__VITE_ASSET__$8gP0se1__"